import ApiError from '../api/ApiError';
import translateMessage from '../api/translateMessage';

const cleanMessage = (value) => (
  typeof value === 'string' ? value.trim() : ''
);

/**
 * Choose the most useful message for a failed user action.
 * Domain-specific copy stays first. Normalized ApiError messages then flow
 * through the single shared translator; arbitrary Error prose never reaches UI.
 */
export function resolveUserFacingError(error, fallback, domainMessage = '') {
  const preferred = cleanMessage(domainMessage);
  if (preferred) return preferred;
  if (error instanceof ApiError) {
    return translateMessage(error.message, error.status, error.params);
  }
  return fallback;
}

export default resolveUserFacingError;
